import { API_PATHS } from '../config';
import { getAccessToken } from '../utils/authStorage';

function buildSseUrl(taskId) {
  let url = `/api${API_PATHS.segmentTaskEvents(taskId)}`;
  const token = getAccessToken();
  if (token) {
    url += `?access_token=${encodeURIComponent(token)}`;
  }
  return url;
}

export function subscribeSegmentTaskEvents(taskId, onEvent) {
  const source = new EventSource(buildSseUrl(taskId));

  source.addEventListener('progress', (event) => {
    try {
      const data = JSON.parse(event.data);
      onEvent(data);
    } catch (e) {
      // ignore malformed payload
    }
  });

  source.onerror = () => {
    source.close();
    if (onEvent.onError) {
      onEvent.onError();
    }
  };

  return () => source.close();
}
